<template>
  <f7-page class="page-add-wallet">
    <f7-navbar>
      <f7-nav-left back-link="Trở lại"></f7-nav-left>
      <f7-nav-title sliding>{{ pool | uppercase }}</f7-nav-title>
    </f7-navbar>
    <wallet2miners v-if="pool === '2miners'" :wallet_info="{pool: pool, coin: coin, name: name, address: address}"></wallet2miners>
  </f7-page>
</template>
<style scoped>
.segmented-strong .button.button-active {
  --f7-button-bg-color : rgba(255, 165, 0, 0.63);
}
small {
  font-size : 9px;
}
small.xs {
  font-size : 8px;
}
small.lg {
  font-size : 12px;
}
.border-right-solid {
  border-right : 1px solid rgba(255, 255, 255, 0.2);
}
.border-bottom-solid {
  border-right : 1px solid rgba(255, 255, 255, 0.2);
}
.bg-color-orange-opacity {
  background-color : rgba(255, 165, 0, 0.43) !important;
}
</style>
<script>
import {
  f7Page,
  f7Navbar,
  f7NavLeft,
  f7NavTitle
} from 'framework7-vue';
import Wallet2miners from "./View2Miners";

export default {
  components: {
    f7Page,
    f7Navbar,
    f7NavLeft,
    f7NavTitle,
    Wallet2miners
  },
  props: {
    pool: String,
    coin: String,
    name: String,
    address: String
  }
};
</script>
